export enum LAUFZEIT {
  ENDALTER = 0,
  JAHRE = 1,
}

export const LAUFZEIT_LABEL: {
  [key in LAUFZEIT]: string;
} = {
  [LAUFZEIT.ENDALTER]: 'Endalter',
  [LAUFZEIT.JAHRE]: 'Laufzeit in Jahren',
};
